var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 37,
    viewBox: "0 0 54 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.272 36.8485H13.8885C1.96584 36.8485 0 32.4181 0 23.175V13.6735C0 3.9515 -1.31563e-06 0 13.8885 0H39.2686C52.6329 0 53.1571 3.44163 53.1571 13.6735V23.175C53.1606 34.2578 50.0393 36.8485 39.272 36.8485Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1484 10.7314L35.4784 18.1659L21.1484 25.6452V10.7314Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7264 19.0823L21.1484 10.7314L35.4784 18.1625L33.7264 19.0823Z",
    fill: "#E6DFDF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0ad9ed07294618272128432b911c8697.svg";
export { ForwardRef as ReactComponent };